import { useContext } from 'react';
import { LoadingSpinner } from '../LoadingSpinner';
import { Main } from '../Main';
import { AppContext } from '../../contexts';

export function RootView() {
  const { isLoading } = useContext(AppContext);

  return (
    <>
      {!isLoading && <Main />}
      <LoadingSpinner isLoading={isLoading} />
    </>
  );
}
